App.SettingsStaffIndexController = Em.Controller.extend
  session: Em.inject.service()

  staffMembersBinding: 'model'

  staffSortOrder: [ 'name' ]
  sortedstaffMembers: Em.computed.sort('staffMembers', 'staffSortOrder')

  actions:
    showStaffMemberPage: (staff) ->
      @transitionToRoute('settings.staff.show', staff.get('id'))
